import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import ChargeField from "./ChargeField";
import getBillingLabel from "../../../../utils/billing/getBillingLabel";
import { sections } from "./constants";

const getCategoryUnit = (key, timeIncrementMinutes) => {
  switch (key) {
    case "materialCharges":
      return "each";
    case "laborCharges":
      const mins = parseInt(timeIncrementMinutes || 60, 10);
      return mins !== 60 ? `per ${mins} minutes` : "per hour";
    case "openInspectCharges":
      return "per item";
    case "equipmentCharges":
      return "each";
    case "oneTimeCharges":
      return "total";
    default:
      return "";
  }
};

export default function ChargeSection({ section, timeIncrementMinutes }) {
  const title = sections.find(s => s.key === section.key)?.title;
  const unit = getCategoryUnit(section.key, timeIncrementMinutes);

  const getStep = () => {
    if (section.key === "laborCharges") {
      const mins = parseInt(timeIncrementMinutes || 60, 10);
      if (mins === 15) return 0.25;
      if (mins === 20) return 0.33;
      if (mins === 30) return 0.5;
    }
    return 1;
  };

  const isDisabled = () => {
    if (section.key === "laborCharges") {
      const mins = parseInt(timeIncrementMinutes || 60, 10);
      return mins !== 60;
    }
    return false;
  };

  return (
    <Box mb={1.5}>
      <Card sx={{ p: 2 }}>
        <Typography fontWeight={500} mb={1} fontSize={17}>
          {title}
        </Typography>
        {section.entries.map(([key, entry]) => (
          <Box key={key} display="flex" justifyContent="space-between" alignItems="center" py={0.5}>
            <Typography>
              {getBillingLabel(key, entry)} {unit && `(${unit})`}
            </Typography>
            <ChargeField 
              name={`${section.key}.${key}`} 
              step={getStep()}
              disabled={isDisabled()}
            />
          </Box>
        ))}
      </Card>
    </Box>
  );
}
